<template>
    <div v-if="model">
        <v-dialog v-model="model" max-width="800">
            <v-card>
                <v-container>
                    <v-card-title>{{ model.name || (model.id ? "Edit Product" : "New Product") }}</v-card-title>
                    <v-card-text>
                        <v-text-field v-model="model.name" label="Name" />
                        <v-select v-model="model.type" :items="productTypes" label="Type" :disabled="!!model.id" />
                        <config-selector :type="model.type" :config="model.configuration" />
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn @click="$emit('cancel')" text :disabled="loading">Cancel</v-btn>
                        <v-btn color="primary" @click="save()" :dark="!loading" depressed :disabled="loading">{{ model.id ? "Update" : "Create" }}</v-btn>
                    </v-card-actions>
                </v-container>
                <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { api } from '@/services/api';
import products from "@/services/products";
import ConfigSelector from "@/components/admin/products/ConfigSelector";

export default {
    props: ["model", "customer"],
    data: () => ({
        productTypes: products.types,
        loading: false
    }),
    methods: {
        async save() {
            let req = {
                "customerId": this.$route.params.id,
                "id": this.model.id,
                "name": this.model.name,
                "type": this.model.type,
                "configuration": this.model.configuration
            };

            this.loading = true;

            await api("/admin/products/save", req);

            this.loading = false;

            this.$emit("close");
        }
    },
    components: { ConfigSelector },
};
</script>